/**
 * preferences.js — the user's explicit choices. [UI-PREFS 2026-10-31]
 *
 * The inline #edugate-boot script in public/index.html reads these keys
 * before the first paint, and treats ONLY them as a choice. They are written
 * here, when a person picks, and nowhere else: the old keys (i18nextLng,
 * darkMode) were also written automatically on load, so a stored value no
 * longer told a choice from an accident.
 */
import i18n, { SUPPORTED_LANGUAGES } from '../i18n';

export const LANGUAGE_KEY = 'edugate.lang';
export const THEME_KEY = 'edugate.theme';

function save(key, value) {
  try { window.localStorage.setItem(key, value); } catch { /* blocked: the choice lasts for this page */ }
}

/** Switch the interface language and remember it. Returns i18next's promise. */
export function setLanguage(lng) {
  if (!SUPPORTED_LANGUAGES.includes(lng)) return Promise.resolve();
  save(LANGUAGE_KEY, lng);
  return i18n.changeLanguage(lng);
}

/** Apply a theme to the page and remember it. Only the toggle calls this. */
export function setTheme(theme) {
  const dark = theme === 'dark';
  document.documentElement.classList.toggle('dark', dark);
  save(THEME_KEY, dark ? 'dark' : 'light');
}
